import { useEffect, useState, useCallback } from "react";
import { Box, Grid } from "@material-ui/core";
import { useStyles } from "./propaganda-list-styles";
import { CircularLoading } from "views/components/utils/circular-loading/circular-loading";
import { useSessaoAtual, useToastSaurus } from "services/app";
import { isEmpty } from "lodash";
import { useHistory } from "react-router";
import { PropagandaListSearchProps } from "./propaganda-list-search-props";
import { useGetPropagandas } from "data/api/gestao/propaganda/get-propagandas";
import { PropagandaListData } from "./propaganda-list-data";
import { PropagandaModel } from "model/api/gestao/propaganda/propaganda-model";
import { ApiListModel } from "model/api/gestao/api-list-model/api-list-model";
import { Paginacao } from "views/components/paginacao";
import { useDefaultCadastroStyles } from "views/pages/private/cadastros/components/default-cadastro-styles";
import { EnumTipoPessoas } from "model/enums/enum-tipo-pessoas";

export interface PropagandaListProps {
  onCardChecked: (id: string) => any;
  searchProps: PropagandaListSearchProps;
}

export const PropagandaList = (props: PropagandaListProps) => {
  const classes = useStyles();

  const { getPropagandas, carregando } = useGetPropagandas();

  const { push } = useHistory();
  const listClasses = useDefaultCadastroStyles();
  const { usuario, tipoUsuario } = useSessaoAtual()
  const { showToast } = useToastSaurus();
  const [selectedList, setSelectedList] = useState<Array<string>>([]);

  const [queryStatus, setQueryStatus] = useState<ApiListModel<PropagandaModel>>({
    pageIndex: 1,
    totalPages: 0,
    totalResults: 0,
    pageSize: 0,
    list: Array<PropagandaModel>(),
  });

  const fillResult = useCallback(
    async (
      page: number,
      totalPages: number,
      totalResults: number,
      list: Array<PropagandaModel>
    ) => {
      setQueryStatus({
        pageIndex: page,
        list: list,
        totalResults: totalResults,
        totalPages: totalPages,
        pageSize: 0
      });
    },
    []
  );

  const search = useCallback(
    async (newPage: number) => {
      try {

        const queryBusca =
          `${!isEmpty(props.searchProps.DtFinal)
            ? '&dtInicial=' + props.searchProps.DtInicial
            : ''
          }${!isEmpty(props.searchProps.DtFinal)
            ? '&dtFinal=' + props.searchProps.DtFinal
            : ''
          }${props.searchProps.Ativo !== -1 ? `&Ativo=${props.searchProps.Ativo}` : ''
          }${!isEmpty(props.searchProps.Descricao)
            ? '&descricao=' + props.searchProps.Descricao
            : ''
          }${!isEmpty(props.searchProps.Local)
            ? '&local=' + props.searchProps.Local
            : ''
          }${tipoUsuario() === EnumTipoPessoas.Revendedor ? `&revendaId=${usuario?.Id}`
            :
            ''
          }`

        const res = await getPropagandas(newPage, queryBusca);

        if (res.erro) throw res.erro;

        if (!res.resultado) return

        fillResult(
          res.resultado?.data.pageIndex,
          res.resultado?.data.totalPages,
          res.resultado?.data.totalResults,
          res.resultado?.data.list,
        );

        return res;
      } catch (e: any) {
        showToast("error", e.message);
      }
    },
    [fillResult, getPropagandas, props.searchProps.Ativo, props.searchProps.Descricao, props.searchProps.DtFinal, props.searchProps.DtInicial, props.searchProps.Local, showToast, tipoUsuario, usuario?.Id]
  );

  const pageChanged = useCallback(
    async (newPage: number) => {
      if (newPage <= queryStatus.totalPages || newPage > 0) {
        search(newPage);
      }
    },
    [search, queryStatus.totalPages]
  );

  useEffect(() => {
    search(queryStatus.pageIndex);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  const onCardSelected = (id: string) => {
    push(`/propaganda/editar/${id}`)
  };

  const onCardChecked = (id: string) => {
    const aux = [...selectedList];
    aux.push(id);
    setSelectedList(aux);
  };

  return (
    <>
      <div className={classes.defaultContainer}>
        {carregando && <CircularLoading tipo="FULLSIZED" />}
        <Box display='flex' flexDirection='column' height='100%' justifyContent='space-between' flex={1} overflow='auto'>
          <Grid container className={listClasses.listContainer}>
            <Grid item xs={12}>
              <Paginacao
                pageChanged={pageChanged}
                totalPages={queryStatus.totalPages}
                totalRegisters={queryStatus.totalResults}
                currentPage={queryStatus.pageIndex}
              />
            </Grid>
            <Grid item xs={12} className={classes.listContainer}>
              <PropagandaListData
                carregando={carregando}
                list={queryStatus.list}
                selectedList={selectedList}
                onCardSelected={onCardSelected}
                onCardChecked={onCardChecked}
              />
            </Grid>
          </Grid>
        </Box>
      </div>
    </>
  );
};